module.exports = __webpack_public_path__ + "img/contacts-icon.7b120198.svg";